import { createContext, Dispatch, SetStateAction } from "react";
import { i18n, SupportedLanguage } from "./index.js";

export type LanguageContextType = [
  SupportedLanguage,
  Dispatch<SetStateAction<SupportedLanguage>>
];

export const LanguageContext = createContext<LanguageContextType>([
  i18n.default,
  () => new Error("Cannot set language outside of provider"),
]);
